<template>
    <a-config-provider :locale="locale" :auto-insert-space-in-button="false">
        <div id="app" :class="[`route-name-${routerName}`]">
            <a-spin :spinning="loading" :tip="loadingTip">
                <router-view />
            </a-spin>
        </div>
    </a-config-provider>
</template>
<script>
import {mapState} from 'vuex';
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN';
import moment from 'moment';
import 'moment/locale/zh-cn';
import {getDomainHandle, setDomainIco} from '@/js/domainUtils';

moment.locale('zh-cn');

export default {
    data() {
        return {
            locale: zhCN
        };
    },
    computed: {
        ...mapState(['loading', 'loadingTip']),
        routerName() {
            return this.$route.name;
        }
        //以上代码相当于，下面两个computed定义
        /*loading(){
				return this.$store.state.loading;
			},
			loadingTip(){
				return this.$store.state.loadingTip;
			}*/
    },
    methods: {},
    mounted() {},
    created() {
        document.title = getDomainHandle('title');
        setDomainIco();
    }
};
</script>
<style lang="scss">
#app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    // text-align: center;
    color: #2c3e50;
}

#nav {
    padding: 30px;

    a {
        font-weight: bold;
        color: #2c3e50;

        &.router-link-exact-active {
            color: #42b983;
        }
    }
}
</style>
